module.exports = __webpack_public_path__ + "img/正在做饭的厨房.bab73daf.png";